module.exports = __webpack_public_path__ + "static/img/yh1.b535235.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/padImg/yh1.png
// module id = +pMx
// module chunks = 1